<template>
<div class="agenda">
  <div class="boma-hero overlay">
    <div class="hero-inner">
      <div class="top-with-navigation">
        <div class="logo">
          <div class="text">
            <p>
              Under the <br class="_rm"/>
              aegis of
            </p>
          </div>
          <div class="image">
            <img src="../../assets/boma/auweblogo-en.svg" alt="">
          </div>
        </div>
        <!-- navigation content -->
          <div id="myNav"  class="overlay-content">
              <button @click="closeNav" class="closebtn">&times;</button>
              <div class="navbar">
                <a href="/">Home</a>
                <a href="/Boma2022/agenda">Agenda</a>
                <a href="/Boma2022/contact">Contact</a>
                <a href="/boma2022/register">Register</a>
              </div>
          </div>
          <!-- toggle button -->
          <button id="nav_toggler" @click="openModal">
            <i class="fas fa-bars"></i>
          </button>
      </div>

      <div class="hero-text">
        <div class="row">
          <div class="col-md-12">
            <div class="image_ text-center">
              <img class="img-fluid" src="../../assets/boma/boma logo.svg" alt="">
              <h2>Agenda</h2>
            </div>
          </div>
        </div>
    </div>
    
    </div>
  </div> 
   <!--END OF HERO  -->
   <div class="agenda-text">
    <div class="row m-0 p-0">
      <div class="col-md-5">
        <h2 class="boma-head">
          Launch of the
          AfCFTA Hub
          Digital Trading
          Corridor
        </h2>
      </div>
      <div class="col-md-7">
         
        <div class="section">
          <h3 class="text-boma-head">
             Launch of AfCFTA Hub
          </h3>
          <p>
            A new digital trading corridor will boost Africa’s SMEs and create jobs.
          </p>
          <p>
            Welcome remarks - Cynthia Gnassingbe-Essonam
          </p>
          <p>
             Keynote Remarks - Wamkele Mene
          </p>
        </div>

        <div class="section">
         <h3>
           Logistics Partners
         </h3>
          <p>—   Mesfin Bekele, Ethiopian Airlines CEO </p>
          <p>—   Allan Kilavuka, Kenya Airways CEO</p>
          <p>—  Yvonne Makolo, RwandAir CEO</p>
          <p>—  Ahadu Simachew, Asky CEO</p>
        </div>
        <div class="section">
          <h3>Digital Champions</h3>
          <p>—  Peter Ndegwa, Safaricom CEO, (TBC)</p>
          <p>—  Ralph Mupita, MTN CEO, (TBC)</p>
        </div>

        <div class="section">
          <h3>Retail Networks</h3>
          <p>—  Kuseni Dlamini, Walmart Africa CEO</p>
        </div>

        <div class="section">
          <h3>Trade Finance</h3>
          <p>—  Benedict Oramah, Afreximbank Chairman</p>
          <p>—  Ade Ayeyemi, Ecobank CEO</p>
          <p>—  Sam Tshabalala, Standard Bank CEO, (TBC)</p>
          <p>—  Sidi Ould Tah, BADEA Director General</p>
        </div>

        <div class="section">
          <h3>SMEs/Startups</h3>
          <p>—  Caravan Laureates</p>
        </div>
          
        <div class="section">
          <h3>AfCFTA Brand Hackathon Finalists </h3>
          <p> —  TQay  </p> 
          <p> —  Nunya  </p>
          <p> —  Tropikal Brand </p>
          <p> —  Brand House Media </p>
          <p> —  Made's Group</p>
        </div>

        <div class="section">
          <h3>
            Prize Givers
          </h3>
          <p>
            — H.E. Mahamadou Issoufou 
          </p>
          <p>
            — Ameenah Gurib-Fakim
          </p>
          <p>
            — Miriem Bensalah-Chaqroun
          </p>
        </div>

        <div class="section">
          <h3>Launching the AfCFTA Hub</h3>
         <p>—  H.E. Hakainde Hichilema launches the AfCFTA Hub</p>
        </div>

      </div>
    </div>
  </div>

  <div class="agenda-text">
    <div class="row m-0 p-0">
      <div class="col-md-5">
        <h2 class="boma-head">
          Symposium 
          on the African
          Century
        </h2>
      </div>
      <div class="col-md-7">
         
        <div class="section">
          <p>
             —  Recovery – Innovative Financing & Overcoming the Fiscal Crisis
          </p>
          <p>
            —  Resilience – Green Industrialisation in a Digital Era
          </p>
          <p>
             —  Rising -  Still an African Century?
          </p>
        </div>

        <div class="section">
         <h3>
           Recovery
         </h3>
          <p>Fireside Chat: Ngozi Okonjo-Iweala, Tidjane Thiam, Paulo Gomes & Makhtar Diop interviewed by Rosa Whitaker  </p>
          <p>Interlocutors: Abla Abdel, Ada Osakwe & Njuguna Ndung’u</p>
        </div>
        <div class="section">
          <h3>Resilience –Champions</h3>
          <p>“The friction of modern development in late industrialising regions”.</p>
          <p>Scene-setting: Dani Rodrik.</p>
          <p>Table: H.E. Cyril Ramaphosa, H.E. Haile Mariam Desalegn, CEO (TBD), Ichiro Kashitani & Ibukun Awosika.</p>
        </div>

        <div class="section">
          <h3>Rising –</h3>
          <p>“Technology & Global Power Shifts”</p>
          <p>Provocateurs: Caroline Atkinson, Nicholas Clegg & Ory Okolloh</p>
        </div>

        <div class="section">
          <h3>Interactive Session with Audience</h3>
          <p>Bringing the World Together in a Time of Crisis (COVID, Ukraine & Climate)</p>
          <p>H.E. Amina Muhammed & Sheikha Moza bint Nasser, Chairperson, Qatar Foundation </p>
        </div>
      </div>
    </div>
  </div>

  <div class="agenda-text">
    <div class="row m-0 p-0">
      <div class="col-md-5">
        <h2 class="boma-head">
          Transcending
          Pandemics
        </h2>
      </div>
      <div class="col-md-7">

        <div class="section">
         <h3 style="color:#000">
            Launch of the African Vaccine Passport & eHealth Backbone
         </h3>
          <p>Welcome Remarks:</p>
          <p>Ahmed Ogwell – co-host</p>
          <p>Matshidiso Moeti – co-host</p>
          <p class="mt-2">Audiovisual </p>
        </div>
        <div class="section">
          <h3>Solidarity Messages </h3>
          <p>—  R.H. S. Iswaran</p>
          <p>—  Representative of India</p>
          <p>—  R.H. Keith Mitchell</p>
          <p>—  ICAO Representative</p>
        </div>

        <div class="section">
          <h3>Official Launch Speech</h3>
          <p>—  H.E. Macky Sall</p>
        </div>

        <div class="section">
          <h3>Vote of Thanks</h3>
          <p>—  H.E. Monique Nsazabaganwa </p>
        </div>

         <div class="section">
          <h3>Distinguished Guests</h3>
          <p>H.E. Tedros Ghebreyesus</p>
          <p>H.E. Achim Steiner</p>
        </div>
         <div class="section">
          <h3>“Envisioning a new Global Public Health Order”</h3>
          <p>—  H.E. Monique Nsazabaganwa —  H.E. John Nkengasong and H.E. Winnie Byanyima, moderated by Reeta Roy</p>
        </div>

        <div class="section">
          <h3>Panel Discussion</h3>
          <p>—  H.E. Albert Muchanga, H.E. Amani Abou-Zeid, H.E. Minata Samate & Ahunna Eziakonwa</p>
        </div>
      </div>
    </div>
  </div>
 <footer>
  <div class="row">
    <div class="col-md-5">
      <p>Boma of Africa | Afrochampions © 2022.  All Rights Reserved</p>
    </div>
    <div class="col-md-7">
      <p>Terms & Conditions. Privacy Policy</p>
    </div>
  </div>
 </footer>
</div>  
</template>

<script>
export default {
  methods: {
    openModal() {
      document.getElementById("myNav").style.display = "block";
    },
    closeNav(){
      console.log('here i am')
      document.getElementById("myNav").style.display = "none";
    }
  }
}
</script>

<style lang="scss" scoped>
  .boma-hero{
    width: 100vw;
    height: 100%;
    margin: 0px;
    background: #008a44;
    background-image: url('../../assets/boma/pattern.svg');
  }
  .hero-inner{
    height: 100%;
    padding-right: 10%;
    padding-left: 10%;
    height: 700px;
    .top-with-navigation{
      display: flex;
      justify-content: space-between;
      .closebtn{
        display: none;
      }
     .logo{
        width: 114px;
        height: 168px;
        border-bottom-right-radius: 70px;
        border-bottom-left-radius: 70px;
        padding-top: 38px;
        padding-left: 24px;
        padding-right: 24px;
        background-color: #fff;
      .text{
        p{
          margin: 0px;
          padding: 0px;
          font-family: 'Montserrat';
          font-style: normal;
          font-weight: 400;
          font-size: 13px;
          line-height: 15px;
          text-align: center;
        }
      }
     }
    // TOP NAVIGATION
     .overlay-content{
      .navbar{
        padding-top: 50px;
        display: block;
        a{
          font-family: 'Montserrat';
          font-style: normal;
          font-weight: 400;
          font-size: 16px;
          line-height: 20px;
          color: #FFFFFF;
          &:not(:last-of-type) {
            margin-right: 22px;
          }
        }
      }
     }
     //NAV TOGGLER
     #nav_toggler{
      display: none;
     }
    }
    .hero-text{
      height: calc(700px - 168px);
      display: flex;
      justify-content: center;
      align-items: center;
      .image_{
        img{
          width: 250px;
          height: 70px;
        }
        h2{
          font-family: 'Montserrat';
          font-style: normal;
          font-weight: 900;
          font-size: 200px;
          //line-height: 244px;
          color: #FFFFFF;
        }
      }
    }
  }
  // footer 
  footer {
    width: 100%;
    background: #FFFFFF;
    padding-left: 10%;
    padding-right: 10%;
    padding-bottom: 50px;
    padding-top: 100px;
    .row {
      p {
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        line-height: 20px;
        color: #1E1E1E;
      }
    }
  }
  // agenda text
    .agenda-text{
      width: 100vw;
      height: 100%;
      padding-right: 10%;
      padding-left: 10%;
      padding-top: 100px;
      background: #FFFFFF;
      overflow: hidden;
      .row{
        .col-md-5{
          .boma-head{
              font-family: 'Montserrat';
              font-style: normal;
              font-weight: 700;
              font-size: 44px;
              // line-height: 78px;
              color: #016537;
          }
        }
        .col-md-7{
          .section{
            h3{
              font-family: 'Montserrat';
              font-style: normal;
              font-weight: 600;
              font-size: 14px;
              line-height: 20px;
              color: #00783E;
              padding-top: 1em;
              padding-bottom: 1em;
              margin: 0px;
            }
            p{
              font-family: 'Montserrat';
              font-style: normal;
              font-weight: 400;
              font-size: 14px;
              line-height: 20px;
              color: #1E1E1E;
              margin-bottom: 0px;
              padding-bottom: .3em;
            }
          }
        }
      }
    }
  // responsiveness
  @media screen and (max-width: 768px) {
    footer {
      padding-bottom: 50px;
      padding-top: 50px;
      text-align: center;
    }
    .agenda-text{
      padding-top: 50px;
      .row{
        overflow: hidden;
        justify-content: center;
        .col-md-5{
          .boma-head{
              font-size: 34px;
              text-align: center;
          }
        }
      }
    }
    ._rm{
      display: none;
    }
    .hero-text{
      height: calc(500px - 168px)!important;
      .image_{
    
        img{
          width: 150px!important;
          height: 70px;
        }
        h2{
          font-family: 'Montserrat';
          margin:0px;
          padding: 0px;
          font-style: normal;
          font-weight: 900;
          width: 100%;
          height: 100%;
          font-size: 60px!important;
          color: #FFFFFF;
        }
      }
    }
    .hero-inner{
      padding-right: 10%;
      padding-left: 10%;
      height: 100%;
    .top-with-navigation{
      .logo{
        background-color: #fff;
        width: 80px;
        height: 120px;
        border-bottom-right-radius: 70px;
        border-bottom-left-radius: 70px;
        padding: 10px;
        padding-top: 20px;
      }
      #nav_toggler{
        display: block;
        width: 50px;
        height: 50px;
        margin-top: 50px;
        background-color: transparent;
        color: #fff;
        font-size: 2.2em;
        outline: none;
        border: none;
      }
      .closebtn {
        display: block;
        font-size: 60px;
        width: 50px;
        height: 50px;
        display: flex;
        justify-content: center;
        align-items: center;
        background: transparent;
        outline: none;
        border:none;
        color: #818181;
        float:right;
        &:hover,&:focus {
            color: #f1f1f1;
          }
      }
      // navigation content
      //  TOP NAVIGATION
    .overlay-content {
      height: 100%;
      width: 100%;
      position: fixed;
      display: none;
      z-index: 1;
      top: 0;
      left: 0;
      background-color: rgb(0,0,0);
      background-color: rgba(0,0,0, 0.9);
      overflow-x: hidden;
      transition: 0.5s;
      .navbar {
          width: 100%;
          text-align: center;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          margin-top: 0px;
          height: calc(100% - 50px);
        a {
          padding: 8px;
          text-decoration: none;
          font-size: 36px;
          color: #818181;
          display: block;
          transition: 0.3s;
          text-align: center;
          
          &:hover,&:focus {
            color: #f1f1f1;
          }
          &:not(:last-of-type) {
            margin-right: 0px;
            margin-bottom: 25px;
          }
        }
      }
    }
    }
  }

  
  }

  // smaller screens
  @media screen and (max-height: 450px) {
  .navbar a {font-size: 20px}
   .top-with-navigatio .closebtn {
    font-size: 40px;
    }
}
</style>